import { Flex, useColorMode } from "@chakra-ui/react";
import React from "react";
import { FaStar, FaStarHalfAlt, FaRegStar } from "react-icons/fa";

interface RatingProps {
  value: number;
  className?: string;
}

const Rating = ({ value, className = "" }: RatingProps) => {
  const wholeStars = Math.floor(value);
  const halfStars = value % 1;
  const emptyStars = 5 - (wholeStars + Math.ceil(halfStars));
  const { colorMode } = useColorMode();

  return (
    <Flex
      color={colorMode === "dark" ? "yellow.200" : "yellow.500"}
      mb="12px"
      className={className}
    >
      {[...Array(wholeStars).keys()].map((i: number) => (
        <FaStar key={i} />
      ))}
      {halfStars ? <FaStarHalfAlt /> : null}
      {[...Array(emptyStars).keys()].map((i: number) => (
        <FaRegStar key={i} />
      ))}
    </Flex>
  );
};

export default Rating;
